import {
    SET_IMAGE_PARTIAL_STICKY,
    SET_IMAGE_STICKY,
    REMOVE_IMAGE_STICKY,
} from '../actionTypes/ProductImageActionTypes';

const setImagePartialSticky = () => ({
    type: SET_IMAGE_PARTIAL_STICKY,
});

const setImageSticky = () => ({
    type: SET_IMAGE_STICKY,
});

const removeImageSticky = () => ({
    type: REMOVE_IMAGE_STICKY,
});

export default {
    setImagePartialSticky,
    setImageSticky,
    removeImageSticky,
};
